module.exports = __webpack_public_path__ + "static/media/dipak-bharali.1214d60e.jpg";